
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cCE4B", function(module, exports) {
/* RecentlyUpdatedMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");




const $50e0564811ea6833$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    heading: {
        id: "recently-updated-macro.heading",
        defaultMessage: "Recent updates"
    },
    noUpdates: {
        id: "recently-updated-macro.no-updates",
        defaultMessage: "No updates yet."
    },
    showMore: {
        id: "recently-updated-macro.show-more",
        defaultMessage: "Show more"
    },
    showMoreAriaLabel: {
        id: "recently-updated-macro.show-more-aria-label",
        defaultMessage: "Show more recent updates"
    },
    showLess: {
        id: "recently-updated-macro.show-less",
        defaultMessage: "Show less"
    },
    filterLabel: {
        id: "recently-updated-macro.filter-label",
        defaultMessage: "Viewing:"
    },
    filterAll: {
        id: "recently-updated-macro.filter-all",
        defaultMessage: "All"
    },
    filterPages: {
        id: "recently-updated-macro.filter-pages",
        defaultMessage: "Pages"
    },
    filterBlogPosts: {
        id: "recently-updated-macro.filter-blog-posts",
        defaultMessage: "Blog Posts"
    },
    filterComments: {
        id: "recently-updated-macro.filter-comments",
        defaultMessage: "Comments"
    },
    filterAttachments: {
        id: "recently-updated-macro.filter-attachments",
        defaultMessage: "Attachments"
    },
    filterWhiteboards: {
        id: "recently-updated-macro.filter-whiteboards",
        defaultMessage: "Whiteboards"
    },
    filterDatabases: {
        id: "recently-updated-macro.filter-databases",
        defaultMessage: "Databases"
    },
    filterEmbeds: {
        id: "recently-updated-macro.filter-embeds",
        defaultMessage: "Embeds"
    },
    createdBy: {
        id: "recently-updated-macro.created-by",
        defaultMessage: "created by {author}"
    },
    updatedBy: {
        id: "recently-updated-macro.updated-by",
        defaultMessage: "updated by {author}"
    },
    createdOn: {
        id: "recently-updated-macro.created-on",
        defaultMessage: "created {date}"
    },
    updatedOn: {
        id: "recently-updated-macro.updated-on",
        defaultMessage: "updated {date}"
    },
    viewChanges: {
        id: "recently-updated-macro.view-changes",
        defaultMessage: "view changes"
    },
    permalink: {
        id: "recently-updated-macro.permalink",
        defaultMessage: "Permalink"
    },
    loadingLabel: {
        id: "recently-updated-macro.loading",
        defaultMessage: "Loading recently updated content\u2026"
    },
    errorMessage: {
        id: "recently-updated-macro.error",
        defaultMessage: "Unable to load recently updated content. Please refresh to try again."
    },
    editCta: {
        id: "recently-updated-macro.edit-cta",
        defaultMessage: "Edit this macro to add content."
    },
    contributedBy: {
        id: "recently-updated-macro.contributed-by",
        defaultMessage: "contributed by {author}"
    },
    commentedBy: {
        id: "recently-updated-macro.commented-by",
        defaultMessage: "commented by {author}"
    },
    commentedByPrefix: {
        id: "recently-updated-macro.commented-by-prefix",
        defaultMessage: "commented by"
    },
    attachedBy: {
        id: "recently-updated-macro.attached-by",
        defaultMessage: "attached by {author}"
    },
    attachedByPrefix: {
        id: "recently-updated-macro.attached-by-prefix",
        defaultMessage: "attached by"
    },
    contributedByPrefix: {
        id: "recently-updated-macro.contributed-by-prefix",
        defaultMessage: "contributed by"
    },
    contributedOn: {
        id: "recently-updated-macro.contributed-on",
        defaultMessage: "contributed {date}"
    }
});






var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $3WQHM = parcelRequire("3WQHM");


var $8mra2 = parcelRequire("8mra2");

// ---------------------------------------------------------------------------
// Helpers to map GraphQL response → UpdateItem
// ---------------------------------------------------------------------------
function $8a15680b4e7af4f7$var$resolveContentType(type, url) {
    const lower = (type ?? '').toLowerCase();
    if (lower === 'blogpost' || lower === 'blog_post') return 'blogpost';
    if (lower === 'comment') return 'comment';
    if (lower === 'attachment') return 'attachment';
    if (lower === 'whiteboard') return 'whiteboard';
    if (lower === 'database') return 'database';
    if (lower === 'embed') return 'embed';
    if (lower === 'userinfo') return 'userinfo';
    if (lower === 'folder') return 'folder';
    const urlLower = (url ?? '').toLowerCase();
    if (urlLower.includes('/whiteboard/')) return 'whiteboard';
    if (urlLower.includes('/database/')) return 'database';
    if (urlLower.includes('/embed/')) return 'embed';
    if (urlLower.includes('/folder/')) return 'folder';
    return 'page';
}
function $8a15680b4e7af4f7$var$formatTimestamp(timestamp) {
    if (!timestamp) return '';
    try {
        return new Date(timestamp).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } catch  {
        return timestamp;
    }
}
function $8a15680b4e7af4f7$var$nodeToUpdateItem(node) {
    if (!node) return null;
    const content = node.content;
    if (!content) return null;
    const status = content.status ?? '';
    if (status === 'archived' || status === 'trashed') return null;
    const id = content.id ?? '';
    const title = content.title ?? '';
    const rawUrl = node.url ?? content.links?.webui ?? '';
    const url = rawUrl && !rawUrl.startsWith('/wiki') ? `/wiki${rawUrl}` : rawUrl;
    const contentType = $8a15680b4e7af4f7$var$resolveContentType(content.type, url);
    const spaceKey = content.space?.key ?? '';
    const spaceName = content.space?.name ?? '';
    // Filter out drafts
    if (!title || url.includes('resumedraft.action')) return null;
    // Date: use lastcontributed.when if available, else fall back to search node's lastModified
    const timestamp = content.metadata?.currentuser?.lastcontributed?.when ?? node.lastModified ?? null;
    const formattedDate = $8a15680b4e7af4f7$var$formatTimestamp(timestamp);
    // Version number determines created vs updated label
    const version = content.version?.number ?? 2;
    // Author from version.by (accountId is on KnownUser inline fragment)
    const versionBy = content.version?.by;
    const authorAccountId = versionBy?.accountId ?? '';
    const author = {
        username: authorAccountId,
        displayName: versionBy?.displayName ?? '',
        profileUrl: authorAccountId ? `/wiki/display/~${encodeURIComponent(authorAccountId)}` : '',
        avatarUrl: versionBy?.profilePicture?.path ?? ''
    };
    return {
        id: id,
        title: title,
        url: url,
        contentType: contentType,
        version: version,
        formattedDate: formattedDate,
        author: author,
        spaceKey: spaceKey,
        spaceName: spaceName
    };
}
function $8a15680b4e7af4f7$export$653b58dbd302c26b(params, cursor = null) {
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { author: author, labels: labels, max: max, spaces: spaces, types: types, currentSpaceKey: currentSpaceKey } = params;
    // Priority: explicit spaces param > currentSpaceKey from handler context > page context
    const spaceKey = spaces ?? currentSpaceKey ?? pageContextSpaceKey ?? '';
    const variables = (0, $42omo.useMemo)(()=>(0, $8mra2.buildRecentlyUpdatedQueryVariables)({
            author: author,
            labels: labels,
            max: max,
            spaces: spaces,
            types: types
        }, spaceKey, cursor ?? ''), [
        author,
        labels,
        max,
        spaces,
        types,
        spaceKey,
        cursor
    ]);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $3WQHM.default), {
        variables: variables,
        __callerPackage__: "@confluence/recently-updated-macro"
    });
    const items = (0, $42omo.useMemo)(()=>{
        const nodes = data?.search?.nodes ?? [];
        const result = [];
        for (const node of nodes){
            const item = $8a15680b4e7af4f7$var$nodeToUpdateItem(node);
            if (item !== null) result.push(item);
        }
        return result;
    }, [
        data
    ]);
    const pageInfo = data?.search?.pageInfo;
    const hasNextPage = pageInfo?.hasNextPage ?? false;
    const endCursor = pageInfo?.endCursor ?? null;
    return {
        items: items,
        loading: loading,
        error: error,
        hasNextPage: hasNextPage,
        endCursor: endCursor
    };
}


function $9e825d39493c30e0$export$da5ffdb7039764e9(params) {
    if (params.theme === 'social' || params.showProfilePic) return 'social';
    if (params.theme === 'sidebar') return 'sidebar';
    return 'concise';
}
function $9e825d39493c30e0$export$189998fb52336f1(items) {
    const groups = [];
    for (const item of items){
        const last = groups[groups.length - 1];
        if (last && last.author.username === item.author.username) last.items.push(item);
        else groups.push({
            author: item.author,
            items: [
                item
            ]
        });
    }
    return groups;
}
function $9e825d39493c30e0$export$d75c1d2d50b43927(items, contentType) {
    if (!contentType) return items;
    return items.filter((item)=>item.contentType === contentType);
}


/* ContentTypeFilter.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $6T8v4 = parcelRequire("6T8v4");




const $90f5fa4c07d892d5$var$styles = {
    filterContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o _6rthutpp"
};
function $90f5fa4c07d892d5$export$950d91f2b2755282({ value: value, onChange: onChange, options: options, filterLabel: filterLabel }) {
    const selectedOption = options.find((o)=>o.value === value) ?? options[0];
    const handleChange = (0, $42omo.useCallback)((option)=>{
        onChange(option?.value ?? '');
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $90f5fa4c07d892d5$var$styles.filterContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span"
    }, filterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        inputId: "recently-updated-filter",
        value: selectedOption,
        options: options,
        onChange: handleChange,
        "aria-label": filterLabel,
        isSearchable: false
    }));
}


/* UpdateItems.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $auNCB = parcelRequire("auNCB");









var $fZtQj = parcelRequire("fZtQj");


var $1yB28 = parcelRequire("1yB28");


var $chO1Z = parcelRequire("chO1Z");


var $5tmwS = parcelRequire("5tmwS");


var $8jHAi = parcelRequire("8jHAi");


var $99wB5 = parcelRequire("99wB5");


var $4ymSL = parcelRequire("4ymSL");


var $ZDq1z = parcelRequire("ZDq1z");


var $9RVmI = parcelRequire("9RVmI");




const $9ee2fdf8f584c862$var$iconProps = {
    label: '',
    color: 'currentColor'
};
const $9ee2fdf8f584c862$var$iconByType = {
    page: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), $9ee2fdf8f584c862$var$iconProps),
    blogpost: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), $9ee2fdf8f584c862$var$iconProps),
    comment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), $9ee2fdf8f584c862$var$iconProps),
    attachment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fZtQj))), $9ee2fdf8f584c862$var$iconProps),
    whiteboard: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), $9ee2fdf8f584c862$var$iconProps),
    database: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), $9ee2fdf8f584c862$var$iconProps),
    embed: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99wB5))), $9ee2fdf8f584c862$var$iconProps),
    userinfo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), $9ee2fdf8f584c862$var$iconProps),
    folder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), $9ee2fdf8f584c862$var$iconProps)
};
function $9ee2fdf8f584c862$export$c7b34dd0f9008ad6({ contentType: contentType }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        "aria-hidden": true
    }, $9ee2fdf8f584c862$var$iconByType[contentType] ?? $9ee2fdf8f584c862$var$iconByType.page);
}


const $d2e25b1814a11d51$var$styles = {
    listItem: "_1rjcu2gc",
    sidebarListItem: "_1rjcu2gc",
    sidebarMeta: "_11c8wadc _qtt81p3b _syaz1rpy _1pfh1b66 _bozgv47k",
    titleRow: "_zulp12x7 _1e0c1txw _4cvr1h6o",
    itemContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    itemMeta: "_11c8wadc _zulp1b66 _syaz1rpy _1pfh1b66 _1e0c1txw _1n261g80 _4cvr1h6o",
    titleLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
function $d2e25b1814a11d51$var$ItemMeta({ item: item }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const dateText = item.formattedDate;
    const authorName = item.author.displayName;
    let authorActionPrefix;
    if (item.contentType === 'comment') authorActionPrefix = formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).commentedByPrefix);
    else if (item.contentType === 'attachment') authorActionPrefix = formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).attachedByPrefix);
    else authorActionPrefix = formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).contributedByPrefix);
    let authorElement = null;
    if (authorName) authorElement = item.author.profileUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: item.author.profileUrl
    }, authorName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, authorName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d2e25b1814a11d51$var$styles.itemMeta
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span"
    }, dateText), authorElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        "aria-hidden": true
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span"
    }, authorActionPrefix, " ", authorElement)), item.changesUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        "aria-hidden": true
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: item.changesUrl
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).viewChanges))));
}
function $d2e25b1814a11d51$export$e242e400758d6e16({ item: item }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "li",
        xcss: $d2e25b1814a11d51$var$styles.listItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d2e25b1814a11d51$var$styles.itemContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d2e25b1814a11d51$var$styles.titleRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ee2fdf8f584c862$export$c7b34dd0f9008ad6), {
        contentType: item.contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: item.url,
        title: item.spaceName,
        xcss: $d2e25b1814a11d51$var$styles.titleLink
    }, item.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d2e25b1814a11d51$var$ItemMeta, {
        item: item
    })));
} // ---------------------------------------------------------------------------
function $d2e25b1814a11d51$export$12e3c7f9d32a480e({ item: item }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "li",
        xcss: $d2e25b1814a11d51$var$styles.sidebarListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d2e25b1814a11d51$var$styles.itemContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $d2e25b1814a11d51$var$styles.titleRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ee2fdf8f584c862$export$c7b34dd0f9008ad6), {
        contentType: item.contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: item.url,
        title: item.spaceName,
        xcss: $d2e25b1814a11d51$var$styles.titleLink
    }, item.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "ul",
        xcss: $d2e25b1814a11d51$var$styles.sidebarMeta
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "li"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).contributedOn, {
        date: item.formattedDate
    })))));
}


/* SocialGroup.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $esRft = parcelRequire("esRft");








var $iXCQx = parcelRequire("iXCQx");



const $97997a1bf316117d$var$styles = {
    titleRow: "_zulp12x7 _1e0c1txw _4cvr1h6o",
    itemContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    itemMeta: "_11c8wadc _zulp1b66 _syaz1rpy _1pfh1b66 _1e0c1txw _1n261g80 _4cvr1h6o",
    titleLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1",
    groupItem: "_zulputpp _1e0c1txw _4cvr1y6m",
    groupContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    nestedList: "_qtt8glyw _1yt4ze3t _18s8ze3t _zulpu2gc _1e0c1txw _2lx21bp4",
    body: "_11c8wadc _syazazsu _1pfh1b66 _zg8l1m30"
};
function $97997a1bf316117d$export$69483b6173afa962({ group: group }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const hasAuthorProfile = Boolean(group.author.profileUrl);
    const hasAuthorName = Boolean(group.author.displayName);
    const avatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: group.author.avatarUrl,
        name: group.author.displayName,
        size: "medium"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "li",
        xcss: $97997a1bf316117d$var$styles.groupItem
    }, hasAuthorProfile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: group.author.profileUrl,
        "aria-label": group.author.displayName
    }, avatar) : avatar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $97997a1bf316117d$var$styles.groupContent
    }, hasAuthorName && (hasAuthorProfile ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: group.author.profileUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong"
    }, group.author.displayName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "strong"
    }, group.author.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "ul",
        xcss: $97997a1bf316117d$var$styles.nestedList
    }, group.items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "li",
            key: item.id,
            xcss: $97997a1bf316117d$var$styles.titleRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ee2fdf8f584c862$export$c7b34dd0f9008ad6), {
            contentType: item.contentType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $97997a1bf316117d$var$styles.itemContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            href: item.url,
            title: item.spaceName,
            xcss: $97997a1bf316117d$var$styles.titleLink
        }, item.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $97997a1bf316117d$var$styles.itemMeta
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span"
        }, item.version === 1 ? formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).createdOn, {
            date: item.formattedDate
        }) : formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).updatedOn, {
            date: item.formattedDate
        })), item.changesUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            "aria-hidden": true
        }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            href: item.changesUrl
        }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).viewChanges))), item.permLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            "aria-hidden": true
        }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            href: item.permLink
        }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).permalink)))), item.body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $97997a1bf316117d$var$styles.body
        }, item.body)))))));
}


/* ShowMoreButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $9hlns = parcelRequire("9hlns");





var $fVUfS = parcelRequire("fVUfS");


var $6mKj3 = parcelRequire("6mKj3");

const $cdd2bed1cad888b3$var$showMoreStyles = {
    button: "_19itglyw _1yt4ze3t _bfhk1j28 _80omtlke",
    showMoreLink: "_11c81d4k _4bfu1r31 _1hmsglyw _ajmmnqa1 _zulp12x7 _syaz13af _1p1d1dk0 _1e0c1txw _4cvr1h6o"
};
function $cdd2bed1cad888b3$export$e41c325c8b11c297({ label: label, ariaLabel: ariaLabel, onClick: onClick, loading: loading }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $cdd2bed1cad888b3$var$showMoreStyles.button,
        "aria-label": (0, $6mKj3.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true) ? ariaLabel : undefined,
        onClick: ()=>{
            if (!loading) onClick();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $cdd2bed1cad888b3$var$showMoreStyles.showMoreLink
    }, label, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small"
    })));
}


const $6e55546115fc9d68$var$styles = {
    container: "_1reo1wug _18m91wug _1rjcpxbi _syazi7uo _1e0c1txw _2lx21bp4 _4t3i1osq",
    heading: "_11c81af2 _syazi7uo _1pfhze3t _6rthpxbi",
    list: "_qtt81wth _18s8ze3t _bozg1ejb",
    sidebarList: "_qtt8glyw _1yt4ze3t _18s8ze3t",
    showMoreContainer: "_1h6d1l7x _1pfhpxbi _1q51u2gc _7myae4h9 _1sw7nqa1 _1e0c1txw _1bah1y6m",
    groupList: "_qtt8glyw _1yt4ze3t _18s8ze3t _zulppxbi _1e0c1txw _2lx21bp4",
    emptyState: "_11c8wadc _1rjcpxbi _syazazsu"
};
function $6e55546115fc9d68$var$isExtensionHandlerProps(value) {
    return Boolean(value && typeof value.mode === 'string' && typeof value.contentId === 'string' && typeof value.extensionKey === 'string' && value.node);
}
function $6e55546115fc9d68$var$getParamRawValue(raw) {
    if (raw && typeof raw === 'object' && 'value' in raw) return raw.value;
    return raw;
}
function $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, key) {
    const explicitRaw = macroParams?.[key];
    if (explicitRaw !== undefined) return $6e55546115fc9d68$var$getParamRawValue(explicitRaw);
    return $6e55546115fc9d68$var$getParamRawValue(macroDefaultProps?.[key]);
}
function $6e55546115fc9d68$var$resolveBoolean(value) {
    if (value === undefined || value === null || value === '') return undefined;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
        if (value.toLowerCase() === 'true') return true;
        if (value.toLowerCase() === 'false') return false;
    }
    return Boolean(value);
}
function $6e55546115fc9d68$var$resolveParams(macroParams, macroDefaultProps) {
    const maxCandidate = $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'max');
    const maxParsed = Number(maxCandidate);
    return {
        theme: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'theme'),
        showProfilePic: $6e55546115fc9d68$var$resolveBoolean($6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'showProfilePic')),
        spaces: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'spaces'),
        types: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'types'),
        author: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'author'),
        labels: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'labels'),
        max: Number.isFinite(maxParsed) && maxParsed > 0 ? Math.floor(maxParsed) : undefined,
        width: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'width'),
        hideHeading: $6e55546115fc9d68$var$resolveBoolean($6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'hideHeading')),
        currentSpaceKey: $6e55546115fc9d68$var$getParamValue(macroParams, macroDefaultProps, 'currentSpaceKey')
    };
}
function $6e55546115fc9d68$var$resolveMaxItems(max) {
    const parsed = Number(max);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : 15;
}
function $6e55546115fc9d68$export$b7b49e8070327f21({ macroDefaultProps: macroDefaultProps, macroParams: macroParams }) {
    const resolvedParams = $6e55546115fc9d68$var$resolveParams(macroParams, macroDefaultProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e55546115fc9d68$export$b4c9dfd209519996, {
        ...resolvedParams,
        macroDefaultProps: macroDefaultProps
    });
}
function $6e55546115fc9d68$export$b4c9dfd209519996({ macroDefaultProps: macroDefaultProps, ...params }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const theme = (0, $9e825d39493c30e0$export$da5ffdb7039764e9)(params);
    const trackingProps = $6e55546115fc9d68$var$isExtensionHandlerProps(macroDefaultProps) ? {
        contentId: macroDefaultProps.contentId,
        extensionKey: macroDefaultProps.extensionKey,
        mode: macroDefaultProps.mode,
        attributes: macroDefaultProps.attributes ?? (0, $5kjCz.getMacroAttributesFromADFNode)(macroDefaultProps.node),
        name: (0, $5kjCz.getExperienceName)(macroDefaultProps.mode, macroDefaultProps.node)
    } : null;
    const [cursor, setCursor] = (0, $42omo.useState)(null);
    const { items: pageItems, loading: loading, error: error, hasNextPage: hasNextPage, endCursor: endCursor } = (0, $8a15680b4e7af4f7$export$653b58dbd302c26b)(params, cursor); // Accumulate items across pages synchronously during render (not in useEffect) so
    // that items are available on the very first render without an extra re-render cycle.
    const accumulatedItemsRef = (0, $42omo.useRef)([]);
    const prevCursorRef = (0, $42omo.useRef)(null);
    if (!loading) {
        if (cursor === null) // Params reset or first load — replace accumulated items with the first page
        accumulatedItemsRef.current = pageItems;
        else if (cursor !== prevCursorRef.current) // New cursor page loaded — append items as returned by the query
        accumulatedItemsRef.current = [
            ...accumulatedItemsRef.current,
            ...pageItems
        ];
        prevCursorRef.current = cursor;
    }
    const itemsForRender = accumulatedItemsRef.current;
    const max = $6e55546115fc9d68$var$resolveMaxItems(params.max);
    const [visibleCount, setVisibleCount] = (0, $42omo.useState)(max); // When key params change, reset to a fresh first-page fetch
    (0, $42omo.useEffect)(()=>{
        setCursor(null);
        accumulatedItemsRef.current = [];
        prevCursorRef.current = null;
        setVisibleCount(max);
    }, [
        max,
        params.spaces,
        params.types,
        params.labels,
        params.author,
        params.currentSpaceKey
    ]);
    const handleShowMore = (0, $42omo.useCallback)(()=>{
        setVisibleCount((prev)=>prev + max); // If we're close to exhausting buffered items, fetch the next GraphQL page
        if (endCursor && itemsForRender.length <= visibleCount + max) setCursor(endCursor);
    }, [
        endCursor,
        itemsForRender.length,
        max,
        visibleCount
    ]);
    const [selectedContentType, setSelectedContentType] = (0, $42omo.useState)('');
    const contentTypeOptions = (0, $42omo.useMemo)(()=>[
            {
                value: '',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterAll)
            },
            {
                value: 'page',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterPages)
            },
            {
                value: 'blogpost',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterBlogPosts)
            },
            {
                value: 'comment',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterComments)
            },
            {
                value: 'attachment',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterAttachments)
            },
            {
                value: 'whiteboard',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterWhiteboards)
            },
            {
                value: 'database',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterDatabases)
            },
            {
                value: 'embed',
                label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterEmbeds)
            }
        ], [
        formatMessage
    ]);
    const handleContentTypeChange = (0, $42omo.useCallback)((val)=>{
        setSelectedContentType(val);
    }, []);
    const filteredItems = (0, $42omo.useMemo)(()=>(0, $9e825d39493c30e0$export$d75c1d2d50b43927)(itemsForRender, selectedContentType), [
        itemsForRender,
        selectedContentType
    ]);
    const visibleItems = filteredItems.slice(0, visibleCount);
    const hasMore = visibleCount < filteredItems.length || hasNextPage;
    const showHeading = !params.hideHeading || visibleItems.length === 0;
    const showFilter = theme === 'social';
    if (loading && itemsForRender.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e55546115fc9d68$var$styles.container,
        testId: "recently-updated-macro"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "h2",
        xcss: $6e55546115fc9d68$var$styles.heading,
        testId: "recently-updated-heading"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e55546115fc9d68$var$styles.emptyState,
        testId: "recently-updated-loading"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).loadingLabel)));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e55546115fc9d68$var$styles.container,
        testId: "recently-updated-macro"
    }, trackingProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JbVPK.MacroExperienceFailure), {
        ...trackingProps,
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e55546115fc9d68$var$styles.emptyState,
        testId: "recently-updated-error"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).errorMessage)));
    if (!loading && visibleItems.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e55546115fc9d68$var$styles.container,
        testId: "recently-updated-macro"
    }, trackingProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), trackingProps), showHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "h2",
        xcss: $6e55546115fc9d68$var$styles.heading,
        testId: "recently-updated-heading"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e55546115fc9d68$var$styles.emptyState,
        testId: "recently-updated-empty"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).noUpdates)));
    let itemList;
    if (theme === 'social') itemList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "ul",
        xcss: $6e55546115fc9d68$var$styles.groupList,
        testId: "recently-updated-social-list"
    }, (0, $9e825d39493c30e0$export$189998fb52336f1)(visibleItems).map((group, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97997a1bf316117d$export$69483b6173afa962), {
            key: group.author.username ? `${group.author.username}-${group.items[0].id}` : `group-${index}`,
            group: group
        })));
    else if (theme === 'sidebar') itemList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "ul",
        xcss: $6e55546115fc9d68$var$styles.sidebarList,
        testId: "recently-updated-list"
    }, visibleItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2e25b1814a11d51$export$12e3c7f9d32a480e), {
            key: item.id,
            item: item
        })));
    else itemList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "ul",
        xcss: $6e55546115fc9d68$var$styles.list,
        testId: "recently-updated-list"
    }, visibleItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2e25b1814a11d51$export$e242e400758d6e16), {
            key: item.id,
            item: item
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e55546115fc9d68$var$styles.container,
        testId: "recently-updated-macro"
    }, trackingProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), trackingProps), showHeading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "h2",
        xcss: $6e55546115fc9d68$var$styles.heading,
        testId: "recently-updated-heading"
    }, formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).heading)), showFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90f5fa4c07d892d5$export$950d91f2b2755282), {
        value: selectedContentType,
        onChange: handleContentTypeChange,
        options: contentTypeOptions,
        filterLabel: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).filterLabel)
    }), itemList, hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $6e55546115fc9d68$var$styles.showMoreContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdd2bed1cad888b3$export$e41c325c8b11c297), {
        label: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).showMore),
        ariaLabel: formatMessage((0, $50e0564811ea6833$export$defe85febe8b728c).showMoreAriaLabel),
        onClick: handleShowMore,
        loading: loading
    })));
}
module.exports["RecentlyUpdatedMacroRendererHandler"] = $6e55546115fc9d68$export$b7b49e8070327f21;
module.exports["RecentlyUpdatedMacroRenderer"] = $6e55546115fc9d68$export$b4c9dfd209519996;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("3WQHM", function(module, exports) {
/**
 * @generated SignedSource<<d93dcd7c10f7020beaca89b6f3698114>>
 * @relayHash 727c301958baf0a557d685e96bfcc728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd
const $0db13d9be330dd35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "url"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContributionStatusSummary",
                        "kind": "LinkedField",
                        "name": "lastcontributed",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "when"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "number"
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "727c301958baf0a557d685e96bfcc728",
            "id": "70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd",
            "metadata": {},
            "name": "RecentlyUpdatedMacroQuery",
            "operationKind": "query",
            "text": "query RecentlyUpdatedMacroQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,lastModified,content{id,type,title,status,space{key,name,id},links{webui},metadata{currentuser{lastcontributed{when}}},version{number,by{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$0db13d9be330dd35$var$node.hash = "7e6233c32402f853522988d79db44911";
var $0db13d9be330dd35$export$2e2bcd8739ae039 = $0db13d9be330dd35$var$node;
module.exports["default"] = $0db13d9be330dd35$export$2e2bcd8739ae039;

});

parcelRegister("8mra2", function(module, exports) {
const $9f74d735080597cb$export$e2092582db731ff4 = 15;
const $9f74d735080597cb$export$31a1864be1d33bad = [
    'page',
    'blogpost',
    'comment',
    'attachment',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $9f74d735080597cb$var$TYPE_ALIASES = {
    news: 'blogpost',
    blog: 'blogpost',
    blogs: 'blogpost',
    'blog-post': 'blogpost',
    blogposts: 'blogpost',
    'blog-posts': 'blogpost',
    pages: 'page',
    comments: 'comment',
    attachments: 'attachment'
};
const $9f74d735080597cb$var$SUPPORTED_TYPES = new Set($9f74d735080597cb$export$31a1864be1d33bad);
function $9f74d735080597cb$var$isContentType(type) {
    return $9f74d735080597cb$var$SUPPORTED_TYPES.has(type);
}
function $9f74d735080597cb$var$normalizeType(rawType) {
    const normalized = $9f74d735080597cb$var$TYPE_ALIASES[rawType] ?? rawType;
    return $9f74d735080597cb$var$isContentType(normalized) ? normalized : undefined;
}
function $9f74d735080597cb$export$bbd572e80a63521b(max) {
    const parsed = Number(max);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : $9f74d735080597cb$export$e2092582db731ff4;
}
function $9f74d735080597cb$export$6a81e704675faae5(params, spaceKey) {
    const clauses = [];
    // Content types
    const collectedTypes = [];
    if (params.types) {
        const splitTypes = String(params.types).split(',');
        for (const t of splitTypes){
            const trimmed = t.trim();
            if (!trimmed) continue;
            const normalizedType = $9f74d735080597cb$var$normalizeType(trimmed.toLowerCase());
            if (normalizedType) collectedTypes.push(normalizedType);
        }
    } else collectedTypes.push(...$9f74d735080597cb$export$31a1864be1d33bad);
    const rawTypes = [
        ...new Set(collectedTypes)
    ];
    if (rawTypes.length > 0) clauses.push(`type in (${rawTypes.join(', ')})`);
    // Space key — defaults to current space
    if (spaceKey) clauses.push(`space = "${spaceKey}"`);
    // Labels
    if (params.labels) {
        const labelList = String(params.labels).split(',').map((l)=>`"${l.trim()}"`).join(', ');
        clauses.push(`label in (${labelList})`);
    }
    // Following users / contributors (author param — comma-separated account IDs)
    if (params.author) {
        const users = String(params.author).split(',').map((u)=>`"${u.trim()}"`).join(', ');
        clauses.push(`contributor in (${users})`);
    }
    return `${clauses.join(' AND ')} order by lastmodified desc`;
}
function $9f74d735080597cb$export$ae985ad2d8a37df8(params, spaceKey, after = '') {
    const maxItems = $9f74d735080597cb$export$bbd572e80a63521b(params.max);
    return {
        cql: $9f74d735080597cb$export$6a81e704675faae5(params, spaceKey),
        cqlcontext: '{"contentStatuses":["draft", "current"]}',
        first: maxItems,
        after: after
    };
}
module.exports["buildRecentlyUpdatedQueryVariables"] = $9f74d735080597cb$export$ae985ad2d8a37df8;

});


//# sourceMappingURL=RecentlyUpdatedMacroRenderer.afa3d7d1.js.map
